import $rdf from '@zazuko/env/web.js';
import { xsd } from '@tpluscode/rdf-ns-builders/loose';
export const TRUE = $rdf.literal('true', xsd.boolean);
